<ng-container *ngIf="page">
  <ade-content *ngIf="page.pageType === 'content'" [slug]="page.slug">
  </ade-content>

  <ade-listing
    *ngIf="page.pageType === 'listing'"
    [config]="page.listing_config"
    [title]="page.title"
    [widgets]="pageWidgets"
  >
  </ade-listing>
</ng-container>

<div class="ade-not-found" *ngIf="notFound">
  <p>{{ "Página não encontrada." | transloco }}</p>
</div>
